import styled from "styled-components";

export const StyledComboBox = styled.div`
  .combo-box-container {
    position: relative;
    width: max-content;
    user-select: none;
    .combo-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px 10px;
      width: calc(164px - 18px);
      background-color: #fff;
      border: 1px solid #d2d2d2;
      border-radius: 4px;
      cursor: pointer;
      .label {
        font-size: 14px;
        font-weight: 200;
        color: #000;
        color: #b2b2b2;
      }
      &.selected .label {
        color: #777;
      }
      & > svg {
        width: 16px;
        height: 16px;
        transition: all 0.2s ease;
      }
      &.active svg {
        transform: rotate(180deg);
      }
    }
    .combo-list {
      top: calc(100% + 4px);
      position: absolute;
      background-color: #fff;
      z-index: 10;
      padding: 0;
      border-radius: 4px;
      box-sizing: border-box;
      width: 100%;
      border: 1px solid #d2d2d2;
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
      overflow: hidden;
      .list {
        cursor: pointer;
        padding: 6px 10px;
        font-size: 12px;
        text-align: start;
        display: flex;
        gap: 4px;
        align-items: center;
        input {
          cursor: pointer;
        }
        &:hover {
          background-color: #e9ebec;
        }
      }
    }
  }
`;
